import { AppError } from "../../../shared/utils/error-handler";
import type { MailIntegrationRepository } from "../../repositories/company/mail-integration-repository";
import type {
  MailIntegrationSetting,
  SaveMailIntegrationRequest,
} from "../../types/mail-integration";

export class MailIntegrationUsecase {
  constructor(
    private mailIntegrationRepository: MailIntegrationRepository,
  ) {}

  async getSetting(companyId: number): Promise<MailIntegrationSetting | null> {
    try {
      return await this.mailIntegrationRepository.getSetting(companyId);
    } catch (error) {
      throw new AppError(
        String(error) || "메일 연동 설정을 불러오지 못했습니다.",
        "MAIL_INTEGRATION_GET_FAILED",
        error,
      );
    }
  }

  async saveSetting(
    companyId: number,
    request: SaveMailIntegrationRequest,
  ): Promise<MailIntegrationSetting> {
    try {
      return await this.mailIntegrationRepository.saveSetting(
        companyId,
        request,
      );
    } catch (error) {
      throw new AppError(
        String(error) || "메일 연동 설정 저장에 실패했습니다.",
        "MAIL_INTEGRATION_SAVE_FAILED",
        error,
      );
    }
  }
}
